import './PageDataComptes.css';
import { useEffect, useState } from 'react';


function PageDataComptes() {
    const [comptes, setComptes] = useState([]);

    useEffect(() => {
        fetch("https://api.famillerocher.fr/get.compta.all.comptes/",{
            method: "GET"
        })
            .then(r => r.json())
            .then(data => {
                // console.log("DATA API:",data);
                setComptes(data)
            })
            .catch(err => console.error("API error:", err));
    }, []);


    
    return (
        // <h1>PageDataComptes</h1>
        <div>
            <ul>
                {comptes.map((compte) => (
                    <li key={compte.id_dc_num}>
                        {compte.id_dc_num} — {compte.dc_label}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default PageDataComptes

